import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabservicepune() {



const cardData =
  {
    keyword: 'One Way Cab Service Pune',
    heading: 'Sanavi Travels: One Way Cab Service Pune',
    headingDescription: 'Sanavi Travels offers reliable, affordable, and professionally managed One Way Cab Service Pune for individuals, families, corporate clients, and travelers who need convenient point-to-point transportation without return charges. One-way cab services are highly preferred in Pune due to frequent outstation travel, airport drops, railway station transfers, corporate relocations, and intercity journeys. With Sanavi Travels, customers can book AC and Non-AC one-way cabs including sedans and SUVs that are clean, comfortable, and well-maintained. Our one-way cab booking eliminates unnecessary round-trip costs, making it a cost-effective and time-saving travel option. Whether you are traveling from Pune to Mumbai, Lonavala, Nashik, Kolhapur, Satara, or nearby destinations, our experienced drivers ensure safe driving, timely pickups, and smooth journeys. Transparent pricing, flexible booking options, professional chauffeurs, and 24/7 customer support make Sanavi Travels a trusted choice for one-way cab services in Pune.',

    top: 'Popular Travel Uses for One Way Cab Service in Pune',


"topPlaces": [
  {
    "title": "One Way Airport Drop in Pune",
    "description": "One-way cab services are widely used for Pune airport drops, especially for early morning and late-night flights. Travelers prefer one-way cabs as they offer direct pickup, ample luggage space, and timely arrival without return fare charges. This makes airport transfers stress-free, economical, and reliable for individuals, families, and corporate travelers."
  },
  {
    "title": "One Way Railway Station Transfers",
    "description": "Passengers traveling to Pune railway stations such as Pune Junction or Shivajinagar station often choose one-way cab services for punctuality and convenience. One-way taxi bookings help avoid parking hassles, ensure comfortable seating, and allow passengers to travel with luggage safely and comfortably."
  },
  {
    "title": "Outstation One Way Travel from Pune",
    "description": "Outstation travelers frequently book one-way cabs from Pune to destinations like Mumbai, Lonavala, Nashik, Satara, Kolhapur, Shirdi, and Aurangabad. One-way cab services reduce overall travel costs while providing flexibility, privacy, and door-to-door convenience."
  },
  {
    "title": "Corporate One Way Cab Travel",
    "description": "Corporate professionals often require one-way cab services for meetings, office relocations, site visits, and official travel. One-way cabs allow employees to travel efficiently without worrying about return logistics, ensuring timely and professional transportation."
  },
  {
    "title": "Relocation and Personal Travel",
    "description": "Individuals relocating or traveling for personal reasons prefer one-way cab services as they provide sufficient luggage space, privacy, and a relaxed journey. This makes long-distance travel more manageable and comfortable."
  },
  {
    "title": "Tourist One Way Cab Usage",
    "description": "Tourists visiting Pune often use one-way cabs for sightseeing drop-offs or onward journeys to nearby destinations. This allows them to plan flexible itineraries without fixed return schedules."
  },
  {
    "title": "Family and Group One Way Trips",
    "description": "Families traveling together for functions, vacations, or events choose one-way cab services to ensure comfortable seating, safety, and easy coordination without multiple vehicles."
  },
  {
    "title": "Late Night and Early Morning Travel",
    "description": "One-way cabs are ideal for late-night or early-morning travel when public transport availability is limited. Professional drivers ensure safe and punctual travel at all hours."
  },
  {
    "title": "Emergency and Short-Notice Travel",
    "description": "For urgent or last-minute travel needs, one-way cab services provide immediate transportation solutions without long booking procedures."
  },
  {
    "title": "City to Highway Connectivity",
    "description": "One-way cab services connect Pune city seamlessly to highways and expressways, making long-distance travel smooth and efficient."
  }
]
,



"services": [
{
"name": "One Way Cab Service Pune",
"description": "One Way Cab Service Pune offers a convenient and economical travel option for passengers who need single-direction transportation without paying for a return trip. Sanavi Travels provides clean, well-maintained sedans and SUVs with experienced drivers, ensuring a comfortable and safe journey. This service is ideal for airport drops, railway station transfers, outstation travel, corporate visits, and personal journeys, offering flexibility, privacy, and cost savings."
},
{
"name": "One Way Taxi Booking Pune",
"description": "One Way Taxi Booking Pune allows travelers to book point-to-point taxi services quickly and easily. With transparent pricing, professional chauffeurs, and multiple vehicle options, this service ensures stress-free travel for short and long distances alike."
},
{
"name": "AC One Way Cab Pune",
"description": "AC One Way Cab Pune provides a cool and comfortable travel experience, especially during long journeys or hot weather. Air-conditioned cabs are preferred for airport transfers, corporate travel, and premium outstation trips."
},
{
"name": "Non AC One Way Cab Pune",
"description": "Non AC One Way Cab Pune is a budget-friendly option suitable for short-distance and economical travel needs while maintaining safety and reliability."
},
{
"name": "Sedan One Way Cab Pune",
"description": "Sedan One Way Cab Pune is ideal for individuals, couples, and small families looking for comfortable and affordable one-way travel within and outside Pune."
},
{
"name": "SUV One Way Cab Pune",
"description": "SUV One Way Cab Pune offers extra space, comfort, and luggage capacity, making it suitable for families, group travel, and long-distance journeys."
},
{
"name": "Outstation One Way Cab Pune",
"description": "Outstation One Way Cab Pune is designed for travelers heading to destinations outside Pune, providing reliable long-distance transportation with professional drivers and comfortable vehicles."
},
{
"name": "One Way Cab for Airport Pune",
"description": "One Way Cab for Airport Pune ensures timely pickups, smooth transfers, and hassle-free travel for domestic and international flights."
},
{
"name": "One Way Cab for Railway Station Pune",
"description": "One Way Cab for Railway Station Pune provides punctual and comfortable transfers for passengers catching trains without worrying about parking or delays."
},
{
"name": "Affordable One Way Cab Pune",
"description": "Affordable One Way Cab Pune delivers cost-effective travel solutions without compromising on service quality, safety, or comfort."
},
{
"name": "Best One Way Cab Service Pune",
"description": "Best One Way Cab Service Pune by Sanavi Travels is trusted for professional drivers, clean vehicles, transparent pricing, and reliable service."
},
{
"name": "One Way Cab with Driver Pune",
"description": "One Way Cab with Driver Pune includes experienced chauffeurs who handle navigation, traffic, and timing, ensuring a smooth journey."
},
{
"name": "Pune to Mumbai One Way Cab",
"description": "Pune to Mumbai One Way Cab is one of the most popular routes, offering fast, comfortable, and economical intercity travel on highways and expressways."
},
{
"name": "Pune to Lonavala One Way Cab",
"description": "Pune to Lonavala One Way Cab is ideal for short leisure trips, weekend travel, and sightseeing journeys."
},
{
"name": "One Way Cab for Corporate Travel Pune",
"description": "One Way Cab for Corporate Travel Pune supports business meetings, office visits, and official travel with punctual and professional transportation."
}
],
"tableData": [
["One Way Cab Service Pune", "One Way Taxi Booking Pune"],
["AC One Way Cab Pune", "Non AC One Way Cab Pune"],
["Sedan One Way Cab Pune", "SUV One Way Cab Pune"],
["Outstation One Way Cab Pune", "Affordable One Way Cab Pune"],
["Airport One Way Cab Pune", "Railway Station One Way Cab Pune"],
["Pune to Mumbai One Way Cab", "Pune to Lonavala One Way Cab"],
["Corporate One Way Cab Pune", "Best One Way Cab Service Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "One Way Cab Service Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and affordable one-way cab services across Pune."
  },
  {
    "WhyChooseheading": "No Return Fare Charges",
    "WhyChoosedescription": "Pay only for one-way travel without unnecessary return costs."
  },
  {
    "WhyChooseheading": "Wide Vehicle Options",
    "WhyChoosedescription": "Sedan and SUV options available for different travel needs."
  },
  {
    "WhyChooseheading": "Professional Drivers",
    "WhyChoosedescription": "Experienced chauffeurs ensure safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "One-way cabs available round the clock."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles",
    "WhyChoosedescription": "Vehicles are cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable Customer Support",
    "WhyChoosedescription": "Customer support available throughout your journey."
  }
]

}

const faqData = [
  {
    question: 'Do you provide one way cab service in Pune?',
    answer: 'Yes, Sanavi Travels provides reliable one-way cab services across Pune.'
  },
  {
    question: 'Are AC and Non AC one way cabs available?',
    answer: 'Yes, both AC and Non-AC one-way cabs are available.'
  },
  {
    question: 'Can I book a one way cab for outstation travel?',
    answer: 'Yes, one-way cabs are available for outstation routes from Pune.'
  },
  {
    question: 'Is the driver included in the one way cab booking?',
    answer: 'Yes, all one-way cab bookings include professional drivers.'
  },
  {
    question: 'Is one way cab service available 24x7?',
    answer: 'Yes, one-way cab services are available round the clock.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ankit Verma',
    feedback: 'Booked a one-way cab from Pune to Mumbai. Smooth ride and reasonable pricing.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Very convenient one-way airport drop service in Pune. Highly recommended.',
    rating: 5
  }
];


























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Service",
//   "name": "One Way Cab Service Pune",
//   "provider": {
//     "@type": "LocalBusiness",
//     "name": "Sanavi Travels",
//     "telephone": "+91 7387507373",
//     "address": {
//       "@type": "PostalAddress",
//       "addressLocality": "Pune",
//       "addressRegion": "Maharashtra",
//       "addressCountry": "IN"
//     }
//   },
//   "description":
//     "Sanavi Travels provides one way cab service in Pune for airport transfers, railway station pickup, corporate travel and outstation taxi service.",
//   "areaServed": {
//     "@type": "City",
//     "name": "Pune"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "ratingValue": 4.7,
//     "bestRating": 5,
//     "worstRating": 1,
//     "ratingCount": 10000
//   }
// };
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/One-Way-Cab-Service-Pune#service",

  "name": "One Way Cab Service Pune",

  "serviceType": "One Way Outstation Cab Service",

  "description":
    "Sanavi Travels provides one way cab service from Pune to outstation destinations with comfortable cars and professional drivers. Book one way cabs for business trips, family travel, airport transfers, relocations and personal journeys without requiring a return booking.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/One-Way-Cab-Service-Pune"
};




  return (
    <div>
<Helmet>
  <title>
    One Way Cab Service Pune | One Way Outstation Taxi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a one way cab service from Pune with Sanavi Travels for outstation trips, business travel, family journeys, airport transfers and relocation. Comfortable cars with professional drivers."
  />

  <meta
    name="keywords"
    content="One Way Cab Service Pune, One Way Cab Pune, One Way Taxi Pune, One Way Outstation Cab Pune, One Way Taxi Service Pune, Pune One Way Cab Booking, One Way Car Rental Pune, Outstation One Way Taxi Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/One-Way-Cab-Service-Pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="One Way Cab Service Pune | One Way Outstation Taxi | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Book a one way cab from Pune for outstation travel, business trips, family journeys, airport transfers and relocation with Sanavi Travels."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/One-Way-Cab-Service-Pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/one-way-cab-service-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    One Way Cab Service Pune | Affordable Outstation Taxi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book One Way Cab Service Pune with Sanavi Travels. Affordable sedan, SUV, AC & Non-AC taxis for airport transfers, railway station pickup, corporate travel and outstation trips. Call 7387507373."
  />

  <meta
    name="keywords"
    content="One Way Cab Service Pune, Pune One Way Taxi, One Way Cab Pune, Pune Outstation Cab, Pune Airport Taxi, Pune Taxi Service, Cab Service Pune, Pune to Mumbai Cab, Pune to Nashik Taxi"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/one-way-cab-service-pune"
  />

  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="One Way Cab Service Pune | Sanavi Travels"
  />
  <meta
    property="og:description"
    content="Affordable One Way Cab Service Pune for airport transfers, corporate travel and outstation trips."
  />
  <meta
    property="og:url"
    content="https://www.sanavitravels.com/one-way-cab-service-pune"
  />
  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/one-way-cab-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/one-way-cab-service-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabservicepune;